import { render, staticRenderFns } from "./TableHeadCol.vue?vue&type=template&id=68e98e81&"
import script from "./TableHeadCol.vue?vue&type=script&lang=js&"
export * from "./TableHeadCol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports